<template>
    <div class="vx-slide-button">
        <div
            class="slide-in"
            :class="{ vertical: vertical }"
            @mouseover="open = true"
            @mouseleave="open = false"
        >
            <transition
                v-for="(button, index) in slideButtons_x"
                :key="index"
                name="button-collapse"
            >
                <div v-if="!index || open" class="button-container" :style="getButtonStyle(index)">
                    <slot :button="button" :index="index">
                        <div
                            class="slide-icon bg-light"
                            :style="`border: 2px solid rgba(var(--vs-${button.color}), 0.2);`"
                        >
                            <vx-action-icon v-bind="button" @click="handleClick($event, button)" />
                        </div>
                    </slot>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VxSlideButton',
    props: {
        slideButtons: {
            type: Array,
            default: () => []
        },
        buttonSpacing: {
            type: String,
            default: '1.25rem'
        },
        vertical: {
            type: Boolean
        }
    },
    data() {
        return {
            open: false,
            transitionTime: 0.25
        }
    },
    computed: {
        slideButtons_x() {
            return this.slideButtons.map(this.standardizeIcon)
        }
    },
    methods: {
        standardizeIcon(icon) {
            return {
                icon: 'SquareIcon',
                color: 'primary',
                ...icon
            }
        },
        handleClick(evt, icon) {
            this.open = false
            if (icon.handler && typeof icon.handler === 'function') {
                icon.handler(evt)
            }
        },
        getButtonStyle(index) {
            var styles = {
                'transition-delay': `${0.05 * index}s`,
                'z-index': 50000 - index,
                'margin-right': this.buttonSpacing
            }
            if (this.vertical) {
                styles['margin-right'] = '0px'
                styles['margin-bottom'] = this.buttonSpacing
            }
            return styles
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/vuexy/_variables.scss';
.slide-in {
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    width: fit-content;
    height: fit-content;
    transition: all 0.3s ease;
    z-index: 0;

    .slide-icon {
        height: 3rem;
        border-radius: 50%;
        padding: 0.75rem;
    }

    .button-collapse-leave-active,
    .button-collapse-enter-active {
        transition: opacity 0.2s, transform 0.3s;
    }

    .button-collapse-leave-to,
    .button-collapse-enter {
        opacity: 0;
        transform: translateX(-150%);
    }

    &.vertical {
        flex-direction: column;

        .button-collapse-leave-to,
        .button-collapse-enter {
            transform: translateY(-150%);
        }
    }
}
</style>
